import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

export const fetchIndicators = () => api.get('/api/indicators');
export const fetchIndicatorHistory = (limit = 50) => api.get(`/api/indicators/history?limit=${limit}`);
export const fetchSystemStatus = () => api.get('/api/system/status');
export const fetchHistorical = (date) => api.get(`/api/historical/${date}`);
export const fetchStrategies = () => api.get('/api/strategies');
export const fetchStrategy = (name) => api.get(`/api/strategies/${name}`);
export const fetchTrades = (strategy = '', limit = 50) =>
  api.get(`/api/trades?strategy=${strategy}&limit=${limit}`);
export const fetchTradeHistory = (params = {}) => api.get('/api/trade-history', { params });
export const fetchBacktest = (date) => api.get(`/api/strategies/backtest/${date}`, { timeout: 120000 });
export const fetchBacktestRange = (from, to) => api.get(`/api/strategies/backtest-range/${from}/${to}`, { timeout: 600000 });
export const fetchBacktestStraddle100 = (date) => api.get(`/api/strategies/backtest-straddle100/${date}`, { timeout: 120000 });
export const fetchBacktestStraddle100Range = (from, to) => api.get(`/api/strategies/backtest-straddle100-range/${from}/${to}`, { timeout: 600000 });
export const fetchBacktestThetaExpiry = (date) => api.get(`/api/strategies/backtest-theta-expiry/${date}`, { timeout: 120000 });
export const fetchBacktestThetaExpiryRange = (from, to) => api.get(`/api/strategies/backtest-theta-expiry-range/${from}/${to}`, { timeout: 600000 });
export const fetchBacktestStraddle50Expiry = (date) => api.get(`/api/strategies/backtest-straddle50-expiry/${date}`, { timeout: 120000 });
export const fetchBacktestStraddle50ExpiryRange = (from, to) => api.get(`/api/strategies/backtest-straddle50-expiry-range/${from}/${to}`, { timeout: 600000 });

// SENSEX backtests
export const fetchBacktestThetaSensexWed = (date) => api.get(`/api/strategies/backtest-theta-sensex-wed/${date}`, { timeout: 120000 });
export const fetchBacktestThetaSensexWedRange = (from, to) => api.get(`/api/strategies/backtest-theta-sensex-wed-range/${from}/${to}`, { timeout: 600000 });
export const fetchBacktestStraddle300SensexWed = (date) => api.get(`/api/strategies/backtest-straddle300-sensex-wed/${date}`, { timeout: 120000 });
export const fetchBacktestStraddle300SensexWedRange = (from, to) => api.get(`/api/strategies/backtest-straddle300-sensex-wed-range/${from}/${to}`, { timeout: 600000 });
export const fetchBacktestThetaSensexExpiry = (date) => api.get(`/api/strategies/backtest-theta-sensex-expiry/${date}`, { timeout: 120000 });
export const fetchBacktestThetaSensexExpiryRange = (from, to) => api.get(`/api/strategies/backtest-theta-sensex-expiry-range/${from}/${to}`, { timeout: 600000 });
export const fetchBacktestStraddle100SensexExpiry = (date) => api.get(`/api/strategies/backtest-straddle100-sensex-expiry/${date}`, { timeout: 120000 });
export const fetchBacktestStraddle100SensexExpiryRange = (from, to) => api.get(`/api/strategies/backtest-straddle100-sensex-expiry-range/${from}/${to}`, { timeout: 600000 });

// Broker accounts
export const fetchAccounts = () => api.get('/api/accounts');
export const createAccount = (data) => api.post('/api/accounts', data, { timeout: 60000 });
export const updateAccount = (id, data) => api.put(`/api/accounts/${id}`, data);
export const deleteAccount = (id) => api.delete(`/api/accounts/${id}`);
export const testAccountConnection = (data) => api.post('/api/accounts/connect', data);
export const setDataFeedAccount = (id) => api.post(`/api/accounts/${id}/set-data-feed`);
export const reconnectAccount = (id) => api.post(`/api/accounts/${id}/reconnect`);
export const getAngelOneLoginUrl = () => api.get('/api/auth/angelone/login-url');
export const getAngelOneDefaultKey = () => api.get('/api/auth/angelone/default-key');
export const getKiteLoginUrl = (accountId) => api.get('/api/auth/kite/login-url', { params: accountId ? { account_id: accountId } : {} });

// Strategy configuration
export const fetchStrategyConfigs = () => api.get('/api/config/strategies');
export const createStrategyConfig = (data) => api.post('/api/config/strategies', data);
export const updateStrategyConfig = (id, data) => api.put(`/api/config/strategies/${id}`, data);
export const deleteStrategyConfig = (id) => api.delete(`/api/config/strategies/${id}`);

// Proxy management
export const getProxyStatus = (accountId) => api.get(`/api/proxy/status/${accountId}`);
export const provisionProxy = (accountId) => api.post(`/api/proxy/provision/${accountId}`);
export const deleteProxy = (accountId) => api.delete(`/api/proxy/${accountId}`);
export const listProxies = () => api.get('/api/proxy/list');

// WebSocket feed
export const getWsFeedStatus = () => api.get('/api/ws-feed/status');
export const restartWsFeed = () => api.post('/api/ws-feed/restart');

// Strategy metadata
export const fetchStrategyMeta = () => api.get('/api/strategy-meta');

export default api;
